module.exports = __webpack_public_path__ + "img/全⾯、⾼可⽤-数据中台体系.596c1973.png";